<template>
  <div />
</template>

<script>
import FirebaseManager from '../../core/firebase/FirebaseManager'
export default {
  async created () {
    await FirebaseManager.Instance.auth().signOut()
    this.$router.replace({ name: 'SignIn', query: this.$route.query })
  }
}
</script>
